<div fxFlex fxLayoutAlign="center" fxLayout="column" class="content-container">
	<h1>404</h1>
	<h2>De pagina die u zoekt, is niet gevonden.</h2>
	<p>
		<a [routerLink]="['/']">Terug naar het overzicht</a>
	</p>
</div>
